import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import {styles} from 'common/lib/styles';
import PartsList from 'client/routes/Customer/PartsList'
import Parts from 'client/routes/Customer/Part'

class PartPrint extends Component {

    constructor (props) {
        super(props)
    }

    componentDidMount() {
        setTimeout(function (){
        window.print();
        }, 1000);
    }

    render () {
        const {classes, parts} = this.props
        return (
             <div className={classes.printRoot}>
                <div className={classes.printSection}>
                    <PartsList {...this.props}/>
                </div>
                {parts.map(p => (
                    <div key={p.id} className={`${classes.printSection} ${classes.printCompact}`}>
                        <Parts part_id={p.id} {...this.props}/> 
                  </div>
                ))}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        parts: state.data.customer.parts,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(PartPrint))